/**
 * If a showing's resolved ticket URL points to this cinema's own `/reservation` page
 * — i.e. it targets the current domain, its path ends with `/reservation` and it has no
 * query params — append `?showingId=<id>` so the reservation form can preselect the
 * showing. Any other ticket URL is returned unchanged.
 */
export function appendReservationShowingId(
    ticketUrl: string | undefined,
    showingId: number,
    currentDomain: string | undefined
): string | undefined {
    if (!ticketUrl || !currentDomain) {
        return ticketUrl;
    }

    const normalizeHost = (host: string): string => host.replace(/^www\./i, '').toLowerCase();
    const base = `https://${normalizeHost(currentDomain)}`;

    let url: URL;
    try {
        // `base` resolves relative links (e.g. "/reservation") against the current domain.
        url = new URL(ticketUrl, base);
    } catch {
        return ticketUrl;
    }

    const isSameDomain = normalizeHost(url.host) === normalizeHost(currentDomain);
    const endsWithReservation = url.pathname.replace(/\/+$/, '').endsWith('/reservation');
    const hasNoQuery = url.search === '';

    if (!isSameDomain || !endsWithReservation || !hasNoQuery) {
        return ticketUrl;
    }

    url.searchParams.set('showingId', String(showingId));
    return url.toString();
}
